import { Trans } from "react-i18next"
import { countryCodeToName } from "@oysterhr/common"
import type {
  AdvisorKnowledgeBase,
  TranslationComponentProps,
  TranslationComponentType,
} from "../../types"
import { useTemplateInfoAdvisor } from "@oysterhr/hiring/templates"

export const HiringTemplatesNote = () => {
  const { templateCountryCode, companyCurrencyCode } = useTemplateInfoAdvisor()

  return (
    <div className="mt-4 space-y-2 bg-gray-100 p-2">
      <Trans
        i18nKey={
          templateCountryCode == null
            ? "hiringTemplates.noteGlobal"
            : "hiringTemplates.noteCountrySpecific"
        }
        ns="knowledge_base/HiringAdvisor"
        values={{
          countryName: templateCountryCode ? countryCodeToName(templateCountryCode) : null,
          companyCurrencyCode,
        }}
      >
        <p className="mb-3 font-bold">Please Note:</p>
        <p className="text-sm">
          This template only includes hiring preferences that apply to all engagements.
        </p>
        <p className="text-sm">
          When you use this template, we’ll check it meets local regulations where you’re hiring and
          let you know if any adjustments are needed.
        </p>
        {templateCountryCode == null && companyCurrencyCode && (
          <p className="text-sm">
            We&apos;ll also convert all amounts in USD to the new hire&apos;s local currency, using
            the exchange rate on the day you start creating the hire.
          </p>
        )}
      </Trans>
    </div>
  )
}

export const withHiringTemplatesNote = <Module extends AdvisorKnowledgeBase>(
  TranslationComponent: Module["TranslationComponent"],
): Module["TranslationComponent"] => {
  type TData = Module extends AdvisorKnowledgeBase<infer U, unknown> ? U : never
  type TExtraInput = Module extends AdvisorKnowledgeBase<unknown, infer V> ? V : never

  const TC = TranslationComponent as TranslationComponentType<TData, TExtraInput>

  return (props: TranslationComponentProps<TData, TExtraInput>) => {
    return (
      <div>
        <TC {...props} />
        <HiringTemplatesNote />
      </div>
    )
  }
}
